export const serviceName = 'getUserProfile';
export const serviceKey = `services_${serviceName}`;
